import {
    UPDATE_GLOBAL_FROM_TIME_TO_TIME
} from "../actions/analyticsDatePickerActions";

export default function(state={}, action){
    switch(action.type){
        case UPDATE_GLOBAL_FROM_TIME_TO_TIME:
            return {
                globalFromTime : action.globalFromTime,
                globalToTime : action.globalToTime,
                presetDate: action.presetDate
            };
        default:
            return state;
    }
}